/**
 * The channels both web notification screens draw.
 *
 * ISSUE-1031. Phone means native iOS and Android push, and `apps/mobile` is
 * paused by `docs/decisions/2026-09-06-mobile-platform-ruling.md`, so a Phone
 * switch on web reaches no device. Stored phone values are not changed. Add
 * `"phone"` back to this list to show the column again. `CHANNEL_COLUMNS`
 * stays the full order, including Phone, for the native screen.
 */
import type { typeChannel } from "./alertKindLabels";

export const WEB_SETTINGS_CHANNELS: readonly typeChannel[] = ["email", "inApp"];
